import { Injectable, signal } from '@angular/core';
import { IArenaDto } from '@models/arena/dtos/arena-dto';
import { ModalSpaceDto } from '@models/arena/dtos/modal-space-dto';
import { ICompetitionDto } from '@models/competition-dto';
import { ISimpleStepParameterizationDto } from '@models/competition/step-paramaterization/dtos/simple-step-parametrization-dto';
import { ClashDto } from '@models/embate/clash-dto';
import { IEventDto } from '@models/event-dto';
import { IPage } from '@models/pagination/page';
import { FilterKeyEnum } from '@shared/services/filter-service/filter-keys';
import { provideFilter } from '@shared/services/filter-service/filter.service';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from 'src/app/core/utilities/base-component/base-component';

@Injectable({
  providedIn: 'root'
})
export class FilterGamesTableService extends BaseComponent {

  constructor() {
    super();
  }

  public selectedArena = signal<IArenaDto | undefined>(undefined);

  private filterFormValueSubject = provideFilter<FilterFormValue>(FilterKeyEnum.FILTER_GAMES_TABLE);
   
  private filterIndependentFormValueSubject = new BehaviorSubject<FilterFormValue>({
    fase: null,
    chave: null,
    arena:null,
    espaco: null,
    competitionDate: null,
    competitionHour: null,
    evento: null,
    competicao: null
  })
  private optionsFilterFormValueSubject = new BehaviorSubject<OptionsFilterFormValue>({})
  private editFightSubject = new BehaviorSubject<boolean>(false);

  filterFormValue$ = this.filterFormValueSubject.observe();
  filterIndepedentFormValue$ = this.filterIndependentFormValueSubject.asObservable();
  editFightValue$ = this.editFightSubject.asObservable();
  optionsFilterFormValue$ = this.optionsFilterFormValueSubject.asObservable();
  
  updateFilterForm(formValue: FilterFormValue) {
    formValue.arena = this.selectedArena()?.areNrId!
    this.filterFormValueSubject.patch({...formValue});
  }

  updateOptionsFilterFormValue(optionsFilterFormValue: OptionsFilterFormValue) {

    this.optionsFilterFormValueSubject.next(optionsFilterFormValue);
  }

  updateFilterIndependentForm(formValue: FilterFormValue) {
    this.filterIndependentFormValueSubject.next(formValue);
  }

  updateEditFight(value: boolean) {
    this.editFightSubject.next(value);
  }

  getCurrentFilterFormValue(): FilterFormValue {
    return this.filterFormValueSubject.get();
  }

  getCurrentFilterIndependetFormValue(): FilterFormValue {
    return this.filterIndependentFormValueSubject.getValue();
  }

  getCurrentOptionsFilterFormValue(): OptionsFilterFormValue {
    return this.optionsFilterFormValueSubject.getValue();
  }

  getCurrentEditFightValue(): boolean {
    return this.editFightSubject.getValue();
  }
}

export interface FilterFormValue {
  fase: number | null,
  chave: number | null,
  arena: number | null,
  espaco: number | null,
  competitionDate: string | null,
  competitionHour: string | null,
  evento: number | null,
  competicao: number | null,
}

export interface OptionsFilterFormValue {
  faseOptions?: IPage<ISimpleStepParameterizationDto>,
  clashOptions?: IPage<ClashDto>,
  arenaOptions?: IPage<IArenaDto>,
  spaceOptions?: ModalSpaceDto[];
  eventOptions?: IPage<IEventDto>;
  competitionOptions?: IPage<ICompetitionDto>;
}


export interface FilterNavigationState {
  petNrId: number | null,
  cheNrId: number | null,
}

